<!-- ============================================================================
     ACTION BUTTONS - Rediseño con botón principal destacado + menú secundario
     UX: Acción más común (añadir cita) siempre visible, resto agrupado
     ============================================================================ -->

<div class="vc-action-buttons">
  <!-- Botón principal: Añadir Cita (acción más frecuente) -->
  <button
    pButton
    class="vc-action-buttons__primary"
    (click)="this.addAppointment()"
    *ngIf="this.hasPermission('APPOINTMENTS.CREATE')"
  >
    <i class="fas fa-calendar-plus"></i>
    <span>{{ "CALENDAR.ADD.APPOINTMENT" | translate }}</span>
  </button>

  <!-- Botón secundario: Añadir Nota -->
  <button
    pButton
    class="vc-action-buttons__secondary"
    (click)="this.addNote()"
    *ngIf="this.hasPermission('CALENDAR_NOTES.CREATE')"
    pTooltip="{{ 'CALENDAR.NOTES.ADD' | translate }}"
    tooltipPosition="bottom"
  >
    <i class="fas fa-sticky-note"></i>
    <span class="vc-action-buttons__label-desktop">{{
      "CALENDAR.NOTES.ADD" | translate
    }}</span>
  </button>
</div>
